import React from 'react';
import InputField from '../../../Components/Form/components/InputField';

const MedicalReportHungaryFields: React.FC = () => {
	return (
		<>
			<InputField
				name='status'
				label='component.medicalReportHungaryFields.status'
				isRequired
				isWrapped
			/>
			<InputField
				name='suggestion'
				label='component.medicalReportHungaryFields.suggestion'
				isRequired
				isWrapped
			/>
			<InputField
				name='prescription'
				label='component.medicalReportHungaryFields.prescription'
				isRequired
				isWrapped
			/>
		</>
	);
};

export default MedicalReportHungaryFields;
